export enum AlertType
{
    Critical = 'CRITICAL',
    Maintenance = 'MAINTENANCE',
    Information = 'INFORMATION'
}

export const alertTypeValues: AlertType[] = [
    AlertType.Critical,
    AlertType.Maintenance,
    AlertType.Information
];
